import React from 'react';
import PropTypes from 'prop-types';
import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip';

import 'echarts/lib/chart/line';
import 'echarts/lib/chart/lines';

import styles from './styles.css';
import NHFetch from '../../utils/NHFetch.js';

const yxxtBasicUrl = 'api/zhxg-yxxt'; //迎新管理服务后台接口基础路径
const errMaxCount = 3; // 请求异常最大次数
const speed = 10 * 1000; //轮询时间间隔

/**
 * * 实时报到人数折线统计图
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-07-04 
 * Version: 1.0
 * Modify log:
 */
class IndexComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            errCount: 0, //连续请求错误次数
            lineData: [], //实时报到人数统计数据
        }

        this.polling; //轮询定时器
    }

    componentDidMount() {
        this.getData();
    }

    componentWillUnmount() {
        //组件卸载时清除轮询定时器
        if (this.polling) {
            clearTimeout(this.polling);
        }
    }

    /**
     * * 获取实时报到人数统计数据
     * @memberof IndexComponent
     */
    getData = () => {

        NHFetch(yxxtBasicUrl + '/sstj/getRealTimeStatisticsForReported', 'GET')
            .then(res => {
                if (res && res.data) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    this.setState({ errCount: 0, lineData: res.data });
                }
            }).catch(err => {
                let errCount = this.state.errCount;
                //如果请求异常次数未超过最大次数限制，则继续尝试
                if (errCount < errMaxCount) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    this.setState({ errCount: errCount + 1 });
                } else {
                    //异常超过3次后终止轮询
                    if (this.polling) {
                        clearTimeout(this.polling);
                    }
                }
            });
    }

    /**
     * * 构造实时报到人数折线图
     * @memberof Home
     */
    getLineOption = () => {
        const { rem, lineData = [] } = this.state;

        const xAxisData = ['08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00'];

        const linesDataObj = {};


        for (let key in lineData) {
            let bdsj = lineData[key].bdsj;
            let bdrs = lineData[key].bdrs;

            linesDataObj[bdsj] = bdrs;
        }

        const seriesData = xAxisData.map(item => {
            if (item in linesDataObj) {
                return linesDataObj[item];
            } else {
                return 0;
            }
        });

        const option = {
            title: {
                text: '实时报到人数',
                textStyle: {
                    color: '#fff',
                    fontSize: 0.14 * rem
                },
                left: '10%'
            },
            tooltip: {
                formatter: function (params) {
                    return params.value;
                }
            },
            grid: {
                top: 20,
                right: 0,
                bottom: 30
            },
            xAxis: {
                type: 'category',
                axisLabel: {
                    color: '#fff',
                    fontSize: 0.12 * rem
                },
                splitLine: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: '#fff',
                        width: 1
                    }
                },
                data: xAxisData
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    color: '#fff',
                    fontSize: 0.12 * rem
                },
                axisLine: {
                    lineStyle: {
                        color: '#fff',
                        width: 1
                    }
                },
                splitLine: {
                    show: false
                },
                interval: 250
            },
            series: [
                {
                    data: seriesData,
                    type: 'line',
                    smooth: true,
                    itemStyle: {
                        normal: {
                            color: '#ffff00'
                        }
                    }
                }
            ]
        };
        return option;
    };

    render() {

        return (
            <div className={styles.lines}>
                <ReactEchartsCore
                    style={{ width: '100%', height: '100%' }}
                    echarts={echarts}
                    option={this.getLineOption()}
                    notMerge={true}
                    lazyUpdate={true}
                />
            </div>
        )
    }

}

IndexComponent.defaultProps = {
}

IndexComponent.propTypes = {
    rem: PropTypes.number,
}

export default IndexComponent;


// WEBPACK FOOTER //
// ./containers/Show-sszy/_LineBox.js